(function () {
  var CSS = [
    '.loox-video-slider-widget{--loox-video-slider-wave-size:0px!important;--loox-u-video-slider-border-radius:14px!important;--loox-video-slider-computed-padding-top:16px!important;--loox-video-slider-computed-padding-bottom:16px!important}',
    '.loox-video-slider-widget .slider-container{--loox-video-slider-wave-size:0px!important}',
    '.loox-video-slider-widget .swiper-slide,.loox-video-slider-widget .viewport{transform:translate(0,0)!important}',
    '.loox-video-slider-widget .swiper-slide-inner,.loox-video-slider-widget .slide-stage,.loox-video-slider-widget .video-slide,.loox-video-slider-widget .viewport{border-radius:14px!important;overflow:hidden}',
    '.loox-video-slider-widget .video-slide .slide-poster img{object-fit:cover}',
    '.loox-video-slider-widget .review-detail .reviewer-name{font-size:14px;font-weight:700;color:#fff;text-shadow:0 1px 6px rgba(0,0,0,.5)}',
    '.loox-video-slider-widget .navigation-button{background:#4a3a52!important;color:#fff!important;border:0!important;box-shadow:0 4px 12px rgba(0,0,0,.18)!important}',
    '@media (max-width:749px){.loox-video-slider-widget .slider-container{transform:scale(.86);transform-origin:top center;margin-bottom:-12%}}'
  ].join('');

  function inject(root) {
    if (!root || root.__ttfLoox) return;
    if (!root.querySelector('.loox-video-slider-widget')) return;
    var s = document.createElement('style');
    s.setAttribute('data-ttf-loox', '');
    s.textContent = CSS;
    root.appendChild(s);
    root.__ttfLoox = true;
  }

  function scan() {
    // light DOM (in case it isn't shadow after all)
    inject(document.head && document.body ? document.body : null);
    // every open shadow root on the page
    var all = document.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      if (all[i].shadowRoot) inject(all[i].shadowRoot);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  var t = 0;
  var iv = setInterval(function () { scan(); if (++t > 40) clearInterval(iv); }, 500);
})();